import { type FC } from 'react';
import { toast } from 'react-toastify';
import type { QueryFilter } from '@domain/schemas/filters.schema';

import { useCreateSavedView } from '../hooks/useSavedViewMutations';
import { SaveViewModal } from '../views/SaveViewModal';

interface SaveViewModalControllerProps {
  handleClose: () => void;
  filters: QueryFilter[];
}

export const SaveViewModalController: FC<SaveViewModalControllerProps> = ({ handleClose, filters }) => {
  const { mutate, isPending } = useCreateSavedView();

  const handleSave = (name: string) =>
    mutate(
      { name, filters },
      {
        onSuccess: () => {
          toast.success('Filtered view saved to the sidebar');
          handleClose();
        },
        onError: () => toast.error('Unable to save view'),
      },
    );

  return <SaveViewModal isLoading={isPending} onCancel={handleClose} onSave={handleSave} />;
};
